export default "__VITE_ASSET__CVLORN2i__"